<template>
  <div class="container-fluid">
    <div class="row">
      <LayoutLeftAuth />

      <div class="col-md-5 ">
        <div
          class="container h-full d-flex align-items-center justify-content-center"
        >
          <div class="row d-flex flex-column text-center align-items-center">
            <img
              src="../../assets/img/logo.png"
              class="logo-mobile-auth d-block d-sm-none"
            />
            <div class="welcome-text">
              Welcome back!
            </div>
            <div class="under-welcome-text">
              Login to your CMS application
            </div>
            <form
              @submit.prevent="login"
              autocomplete="no"
              class="new-auth-form"
            >
              <div class="material-textfield first-input">
                <input
                  v-model="auth.email"
                  id="email"
                  name="email"
                  type="text"
                  placeholder=" "
                  autofocus
                />
                <label>Email</label>
              </div>
              <error-field
                :errors="errors"
                field="email"
                class="material-errors"
              />
              <div class="material-textfield second-input">
                <input
                  v-model="auth.password"
                  id="password"
                  name="password"
                  type="password"
                  placeholder=" "
                />
                <label>Password</label>
              </div>
              <error-field
                :errors="errors"
                field="password"
                class="material-errors"
              />
              <error-field
                :errors="errors"
                field="credentials"
                class="material-errors"
              />
              <error-field
                :errors="errors"
                field="exception"
                class="material-errors"
              />
              <input
                type="submit"
                class="btn btn-primary login-button hover-btn-bg"
                value="Login"
              />
            </form>

            <router-link class="thick-font" to="forgot-password"
              >Forgot password?</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutLeftAuth from "../../components/auth/LayoutLeftAuth";
import { mapActions, mapGetters } from "vuex";
import Errors from "@/classes/Errors";
import ErrorField from "@/components/ErrorField";

export default {
  components: {
    ErrorField,
    LayoutLeftAuth
  },
  data: () => ({
    auth: {
      email: "",
      password: ""
    },
    errors: new Errors(),
    fakeError: false,
    userStatusError: false
  }),
  computed: {
    ...mapGetters({
      userData: "userData"
    })
  },
  methods: {
    ...mapActions(["authLogin"]),
    login() {
      this.userStatusError = false;
      this.authLogin({ ...this.auth })
        .then(() => {
          this.$router.push("/posts");
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
          console.log();
          this.$vToastify.error(
            err.response.data.error,
            "Error " + err.response.status
          );
        });
    },
    clearError(event) {
      if (this.errors.has("credentials")) {
        this.errors.clear("credentials");
      }
      if (this.errors.has("exception")) {
        this.errors.clear("exception");
      }
      this.errors.clear(event.target.name);
    }
  }
};
</script>
<style scoped>
.welcome-text {
  font-weight: 500;
  font-size: 40px;
  line-height: 48px;
  letter-spacing: -0.72px;
  color: #131c36;
  margin-bottom: 7px;
}
.under-welcome-text {
  font-size: 18px;
  line-height: 24px;
  color: #3e475e;
  margin-bottom: 45px;
}
.first-input {
  margin-bottom: 18px;
}
.second-input {
  margin-bottom: 40px;
}
.under-button-text {
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #3e475e;
  margin-top: 60px;
  margin-bottom: 20px;
}
.sign-up-btn {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #006266;
  padding: 18px 0;
  border: 1px solid #f2f2f2;
  box-sizing: border-box;
  border-radius: 3px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  width: 310px;
}

.sing-up-btn:active,
.sign-up-btn:hover,
.sign-up-btn:visited,
.sign-up-btn:focus {
  background: #02585a !important;
  -webkit-box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25) !important;
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
}
.hover-btn-bg:hover,
.hover-btn-bg:focus,
.hover-btn-bg:visited,
.hover-btn-bg:active {
  background: #02585a !important;
  -webkit-box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25) !important;
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25) !important;
}

.foreman-arrow-respo a {
  color: white;
}
</style>
